module.exports = __webpack_public_path__ + "static/media/posts-nav-buttton.f2c1870b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scss/imgs/posts-nav-buttton.svg
// module id = 6
// module chunks = 0